<template>
  <div class="vg-invoice-popup-picker">
    <div class="vg-picker-input">
      <input readonly :value="selected && selected.text" @click="onClick" :placeholder="title"/>
      <van-image width="12" height="12" :src="srcDown"/>
    </div>
    <vg-popup class="vg-popup-picker-popup" v-model="show" position="bottom" get-container="#app">
      <vg-picker show-toolbar
                 :title="title"
                 :value="selected"
                 :columns="columns"
                 @confirm="onConfirm"
                 @cancel="onCancel"/>
    </vg-popup>
  </div>
</template>

<script>
import {Image as VanImage, Toast} from "vant";
import VgPicker from "@/components/Commons/VgPicker";
import VgPopup from "@/components/Commons/VgPopup";
import srcDown from "@/assets/more.svg";

export default {
  name: "VgInvoicePopupPicker",
  components: {
    VanImage,
    VgPopup,
    VgPicker,
  },
  props: {
    value: {
      type: String,
    },
    title: {
      type: String,
    },
    columns: {
      type: Array,
      default() {
        return [];
      }
    },
    hasProjectId: {
      type: Boolean,
    },
  },
  data() {
    return {
      srcDown: srcDown,
      show: false,
    };
  },
  computed: {
    selected() {
      return this.columns.filter(item => item.value === this.value)[0]
    }
  },
  methods: {
    onClick() {
      console.log(this.hasProjectId)
      if (!this.hasProjectId) {
        Toast("请选择项目");
        return;
      }
      this.show = !this.show;
    },
    onConfirm(value) {
      this.$emit('input', value.value)
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
  }
}
</script>

<style scoped>
.vg-invoice-popup-picker {
  width: 100%;
}

.vg-picker-input {
  height: 32px;
  margin-top: 10px;
  padding: 0 10px;
  border-radius: 3px;
  border: 1px solid #BBBBBB;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vg-picker-input input {
  margin-right: 15px;
  border: none;
  color: #101010;
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex-grow: 1;
}

.vg-picker-input input::placeholder {
  color: #B4B1B1;
}

.vg-popup-picker-popup {
  border-radius: 10px 10px 0 0;
}
</style>